import { cn } from "../ui/utils";

export function ThemeCard({
  title,
  description,
  tokens,
  emoji,
  active = false,
  onClick,
  className,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "w-full rounded-xl border border-border/60 bg-white px-4 py-4 text-left transition hover:border-primary/60 hover:shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:ring-offset-2",
        active
          ? "border-primary bg-primary/5"
          : "",
        className
      )}
    >
      <div className="flex items-start gap-3">
        <div className="text-xl">{emoji}</div>
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <p className="text-sm font-semibold text-foreground">{title}</p>
            {tokens != null && (
              <span className="flex items-center gap-1 text-xs font-semibold text-muted-foreground">
                ⭐ {tokens}
              </span>
            )}
          </div>
          <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
            {description}
          </p>
        </div>
      </div>
    </button>
  );
}

